import React, { useState, useEffect } from "react";
import "./VmEditComponent.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import leftArrow from "../../../../assests/leftArrow.svg";
import IconButton from "@mui/material/IconButton";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Menu from "@mui/material/Menu";
import { useTheme } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Chip from "@mui/material/Chip";
import cancel from "../../../../assests/cancel.svg";
import LoadingSpinner from "../../../Loading/component";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Table from "react-bootstrap/Table";
import { Popover } from "@mui/material";
import Dropdown from "react-bootstrap/Dropdown";
import filter from "../../../../assests/filterIcon.svg";
import search from "../../../../assests/search.svg";

const VmEditComponent = (props) => {
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();

  const [state, setState] = useState({
    showWarehouseList: false,
    showVMTypeList: false,
    showHardwareList: false,
    showCorporateList: false,
    anchorElConsumerApp: null,
    anchorElHealthApp: null,
    showStateList: false,
    showCityList: false,
    showLocationType: false,
    isStateSelected: false,
    searchTerm: "",
    anchorEl: null,
    open: false
  });

  const handleOpen = () => setState({ ...state, open: true });
  const handleClose = () => {
    props.Search("");
    setState({ ...state, open: false });
  };

  useEffect(() => {
    if (!state.open) {
      props.Search("");
    }
  }, [state.open]);

  const goback = () => navigate(-1);

  const handleConsumerAppClick = (event) => {
    setState({ ...state, anchorElConsumerApp: event.currentTarget });
  };

  const handleConsumerAppSelect = (value) => {
    setState({ ...state, anchorElConsumerApp: null });
    props.handleInputChange("consumer_app_enabled", value === 1);
  };

  const handleHealthAppClick = (event) => {
    setState({ ...state, anchorElHealthApp: event.currentTarget });
  };

  const handleHealthAppSelect = (value) => {
    setState({ ...state, anchorElHealthApp: null });
    props.handleInputChange("health_report_enabled", value);
  };

  useEffect(() => {
    if (props.formData) {
      const initialMachineType = props.vmTypeList.find(
        type => type.id === props.formData.machine_type_id
      );
      if (initialMachineType) {
        props.setSelectedMachineTypeId(initialMachineType.id);
        props.setSelectedMachineTypeName(initialMachineType.name);
      }

      const initialHardwareType = props.hardwareList.find(
        type => type.id === props.formData.hardware_type_id
      );
      if (initialHardwareType) {
        props.setSelectedHardwareTypeId(initialHardwareType.id);
        props.setSelectedHardwareTypeName(initialHardwareType.name);
      }
    }
  }, [props.formData, props.vmTypeList, props.hardwareList]);

  const handleVMTypeChange = (event) => {
    const selectedValue = event.target.value;
    props.setSelectedMachineTypeId(selectedValue);
    const selectedVMType = props.vmTypeList.find(type => type.id === selectedValue);
    if (selectedVMType) {
      props.setSelectedMachineTypeName(selectedVMType.name);
      props.handleInputChange("machine_type_id", selectedVMType.id);
    }
  };

  const handleHardwareChange = (event) => {
    const selectedValue = event.target.value;
    props.setSelectedHardwareTypeId(selectedValue);
    const selectedHardwareType = props.hardwareList.find(type => type.id === selectedValue);
    if (selectedHardwareType) {
      props.setSelectedHardwareTypeName(selectedHardwareType.name);
      props.handleInputChange("hardware_type_id", selectedHardwareType.id);
    }
  };

  const handleStateNameChange = (stateId) => {
    props.setStateId(stateId);
    props.handleInputChange("state", stateId);
    setState({ ...state, showStateList: false });
    props.handleGetCityName(stateId);
  };

  const handleCityNameChange = (selectedCity) => {
    props.handleInputChange("city", selectedCity);
    setState({ ...state, showCityList: false });
  };

  const handleLocationTypeChange = (selectedLocationType) => {
    props.setFormData(prevFormData => ({
      ...prevFormData,
      address: {
        ...prevFormData.address,
        location_type_id: selectedLocationType,
      },
    }));
    setState({ ...state, showLocationType: false });
  };

  const handleWarehouseChange = (selectedWarehouseId) => {
    const selectedWarehouse = props.warehouseList.find(
      el => el.warehouseId === selectedWarehouseId
    );
    if (selectedWarehouse) {
      const updateWarehouse = {
        id: selectedWarehouse.warehouseId,
        name: selectedWarehouse.warehouseName,
      };
      props.handleInputChange("warehouse", updateWarehouse);
      setState({ ...state, anchorEl: null, searchTerm: "" });
    }
  };

  const handleSearchChange = (event) => {
    setState({ ...state, searchTerm: event.target.value });
  };

  const filteredWarehouseList = props.warehouseList
    .filter(warehouse =>
      warehouse.warehouseName.toLowerCase().includes(state.searchTerm.toLowerCase())
    )
    .sort((a, b) => a.warehouseName.localeCompare(b.warehouseName));

  const handleClick = (event) => {
    setState({ ...state, anchorEl: event.currentTarget });
  };

  const handleClose1 = () => {
    setState({ ...state, anchorEl: null, searchTerm: "" });
  };

  const handleCorporateChange = (selectedCorporateId) => {
    const selectedCorporate = props.corporateList.find(
      el => el.id === selectedCorporateId
    );
    if (selectedCorporate) {
      const updatedCorporate = {
        id: selectedCorporate.id,
        name: selectedCorporate.name,
      };
      props.handleInputChange("corporate", updatedCorporate);
      setState({ ...state, showCorporateList: false });
    }
  };

  const handleCheckboxChange = (e, cohortId) => {
    const checked = e.target.checked;
    checked ? props.addCohorthandleClick(cohortId) : props.removedCohort(cohortId);
  };

  // const handleTypeChange = (e) => {
  //   props.setFormData({
  //     ...props.formData,
  //     type: e.target.value,
  //     type_detail: ''
  //   });
  // };

  // const handleDetailChange = (e) => {
  //   props.setFormData({
  //     ...props.formData,
  //     type_detail: e.target.value
  //   });
  // };
  const handleTypeChange = (e) => {
    props.setFormData({
      ...props.formData,
      type: e.target.value,
      type_detail: '' // reset when main type changes
    });
  };

  const handleDetailChange = (e) => {
    props.setFormData({
      ...props.formData,
      type_detail: e.target.value
    });
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '1390px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto'
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="vm-edit-container">
          <div className="vm-edit-sidebar">
            <Sidebar />
          </div>

          <div className="vm-edit-content">
            <div className="vm-edit-header">
              <img
                onClick={goback}
                className="vm-edit-back-arrow"
                src={leftArrow}
                alt="Back"
              />
              <h2 className="vm-edit-title">Edit Vending Machine</h2>
            </div>

            <div className="vm-edit-main-container">
              <div className="vm-edit-form-container">
                {/* Section 1 */}
                <div className="vm-edit-form-section">
                  <div className="vm-edit-section-number">1</div>

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="VM Name"
                    value={props.formData.name || ""}
                    onChange={(e) => props.handleInputChange("name", e.target.value)}
                  />

                  <FormControl className="vm-edit-select">
                    <InputLabel>VM Type</InputLabel>
                    <Select
                      value={props.selectedMachineTypeId || ""}
                      onChange={handleVMTypeChange}
                      label="VM Type"
                      InputLabelProps={{ shrink: !!props.selectedMachineTypeId }}
                    >
                      {props.vmTypeList.length > 0 ? (
                        props.vmTypeList.map(el => (
                          <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>No VM Types available</MenuItem>
                      )}
                    </Select>
                  </FormControl>

                  <FormControl className="vm-edit-select">
                    <InputLabel>Hardware Type</InputLabel>
                    <Select
                      label="hardware_type_id"
                      value={props.selectedHardwareTypeId || ""}
                      onChange={handleHardwareChange}
                      InputLabelProps={{ shrink: !!props.selectedHardwareTypeId }}
                    >
                      {props.hardwareList.length > 0 ? (
                        props.hardwareList.map(el => (
                          <MenuItem value={el.id} key={el.id}>{el.name}</MenuItem>
                        ))
                      ) : (
                        <MenuItem disabled>No Hardware Types available</MenuItem>
                      )}
                    </Select>
                  </FormControl>

                  <FormControl className="vm-edit-select">
                    <InputLabel>Warehouse</InputLabel>
                    <Select
                      label="Warehouse"
                      value={(props.formData && props.formData.warehouse.id) || ""}
                      onClick={handleClick}
                      onChange={(e) => handleWarehouseChange(e.target.value)}
                      open={Boolean(state.anchorEl)}
                      renderValue={(selected) => {
                        const selectedWarehouse = props.warehouseList.find(
                          el => el.warehouseId === selected
                        );
                        return selectedWarehouse ? selectedWarehouse.warehouseName : "";
                      }}
                    />
                    <Menu
                      anchorEl={state.anchorEl}
                      open={Boolean(state.anchorEl)}
                      onClose={handleClose1}
                      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                      transformOrigin={{ vertical: "top", horizontal: "left" }}
                      className="vm-edit-warehouse-menu"
                    >
                      <div className="vm-edit-warehouse-search-container">
                        <TextField
                          placeholder="Search Warehouse"
                          value={state.searchTerm}
                          onChange={handleSearchChange}
                          fullWidth
                          onClick={(e) => e.stopPropagation()}
                        />
                        {filteredWarehouseList.length > 0 ? (
                          filteredWarehouseList.map((el, index) => (
                            <MenuItem
                              key={index}
                              value={el.warehouseId}
                              onClick={() => handleWarehouseChange(el.warehouseId)}
                            >
                              {el.warehouseName}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No results found</MenuItem>
                        )}
                      </div>
                    </Menu>
                  </FormControl>

                  <FormControl className="vm-edit-select">
                    <InputLabel>Corporate</InputLabel>
                    <Select
                      label="corporate"
                      value={props.formData.corporate.id || ""}
                      onChange={(e) => handleCorporateChange(e.target.value)}
                    >
                      {props.corporateList && props.corporateList.map((el, index) => (
                        <MenuItem value={el.id} key={index}>{el.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl className="vm-edit-select">
                    <InputLabel>Consumer App Enabled</InputLabel>
                    <Select
                      label="Consumer App Enabled"
                      value={props.formData.consumer_app_enabled ? 1 : 0}
                      onChange={(e) => handleConsumerAppSelect(e.target.value)}
                      onClick={handleConsumerAppClick}
                    >
                      {[{ id: 0, name: "NO" }, { id: 1, name: "YES" }].map((el, index) => (
                        <MenuItem value={el.id} key={index}>{el.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl className="vm-edit-select">
                    <InputLabel>Health App Enabled</InputLabel>
                    <Select
                      label="Health App Enabled"
                      value={props.formData.health_report_enabled == false ? 0 : 1 || ""}
                      onChange={(e) => handleHealthAppSelect(e.target.value)}
                      onClick={handleHealthAppClick}
                    >
                      {[{ id: 0, name: "NO" }, { id: 1, name: "YES" }].map((el, index) => (
                        <MenuItem value={el.id} key={index}>{el.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl className="vm-edit-select">
                    <InputLabel>Internet Provider</InputLabel>
                    <Select
                      label="Internet Provider"
                      value={props.formData.internet_provider || ''}
                      onChange={(e) => {
                        props.setFormData({
                          ...props.formData,
                          internet_provider: e.target.value
                        });
                      }}
                    >
                      <MenuItem value="JIO">JIO</MenuItem>
                      <MenuItem value="VI">VI</MenuItem>
                      <MenuItem value="Airtel">Airtel</MenuItem>
                      <MenuItem value="Wi-Fi provide by us">Wi-Fi provide by us</MenuItem>
                      <MenuItem value="Wi-Fi provide by Them">Wi-Fi provide by Them</MenuItem>
                      <MenuItem value="LAN by us">LAN by us</MenuItem>
                      <MenuItem value="LAN by Them">LAN by Them</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                {/* Section 2 */}
                <div className="vm-edit-form-section">
                  <div className="vm-edit-section-number">2</div>

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="Share Percentage"
                    value={
                      props.formData &&
                        (props.formData.share_percentage ||
                          props.formData.share_percentage === 0)
                        ? props.formData.share_percentage
                        : ""
                    }
                    onChange={(e) =>
                      props.handleInputChange("share_percentage", e.target.value)
                    }
                  />

                  <div className="vm-edit-cohorts-container">
                    <p className="vm-edit-cohorts-label">Cohorts</p>
                    <Button
                      variant="outlined"
                      onClick={handleOpen}
                      className="vm-edit-cohorts-button"
                    >
                      Cohorts
                    </Button>
                  </div>

                  <Modal
                    open={state.open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={modalStyle}>
                      <div className="vm-edit-modal-header">
                        <img
                          onClick={handleClose}
                          className="vm-edit-modal-back-arrow"
                          src={leftArrow}
                          alt="Back"
                        />
                        <h2 className="vm-edit-modal-title">Edit Vending Machine</h2>
                      </div>

                      <div className="vm-edit-cohorts-modal">
                        <div className="vm-edit-cohorts-search">
                          <input
                            type="search"
                            placeholder="Search by Cohort Name/ Cohort ID"
                            onChange={(e) => props.Search(e.target.value)}
                          />
                          <img
                            className="vm-edit-cohorts-search-icon"
                            src={search}
                            alt="Search"
                          />
                        </div>

                        <div className="vm-edit-cohorts-table-container">
                          <Table striped className="vm-edit-cohorts-table">
                            <thead>
                              <tr>
                                <th>Cohort ID</th>
                                <th>Cohort Name</th>
                                <th>Area Name</th>
                                <th className="vm-edit-cohorts-type-header">
                                  <Dropdown className="vm-edit-cohorts-dropdown">
                                    <Dropdown.Toggle variant="none" className="vm-edit-cohorts-dropdown-toggle">
                                      <img src={filter} alt="Filter" />
                                      <span>Cohort Type</span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      {props.stagecohortsTypes && props.stagecohortsTypes.map(item => (
                                        <Dropdown.Item
                                          key={item.id}
                                          id={item.id}
                                          active={props.activeCohortType === item.id}
                                          onClick={() => props.handleCohortTypeClick(item.id, item.type)}
                                        >
                                          {item.name}
                                        </Dropdown.Item>
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </th>
                                <th></th>
                              </tr>
                            </thead>

                            <tbody>
                              {props.FilterCohortData &&
                                props.FilterCohortData.length > 0 ? (
                                props.FilterCohortData.sort((a, b) => {
                                  const aChecked = props.userdetailsCohort?.find(dt => dt.id === a.id);
                                  const bChecked = props.userdetailsCohort?.find(dt => dt.id === b.id);
                                  if (aChecked && !bChecked) return -1;
                                  if (!aChecked && bChecked) return 1;
                                  return 0;
                                }).map((el, index) => (
                                  <tr key={el.id}>
                                    <td>{el.id}</td>
                                    <td>{el.name}</td>
                                    <td>{el.area_name}</td>
                                    <td className="vm-edit-cohorts-type">{el.type}</td>
                                    <td>
                                      <input
                                        id={el.id}
                                        type="checkbox"
                                        className="vm-edit-cohorts-checkbox"
                                        onChange={(e) => {
                                          if (props.userdetailsCohort?.find(dt => dt.id === el.id)) {
                                            props.removedCohort(e, el.id);
                                          } else {
                                            props.addCohorthandleClick(e);
                                          }
                                        }}
                                        checked={!!props.userdetailsCohort?.find(dt => dt.id === el.id)}
                                      />
                                    </td>
                                  </tr>
                                ))

                              ) : (
                                <tr>
                                  <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                                    No cohort found
                                  </td>
                                </tr>
                              )}


                            </tbody>
                          </Table>
                        </div>

                        <div className="vm-edit-cohorts-modal-buttons">
                          <Button
                            className="vm-edit-cohorts-back-button"
                            onClick={handleClose}
                          >
                            Back
                          </Button>
                          <Button
                            className="vm-edit-cohorts-save-button"
                            onClick={handleClose}
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                    </Box>
                  </Modal>

                  <FormControl className="vm-edit-select">
                    <InputLabel>Payments</InputLabel>
                    <Select
                      label="Payments"
                      multiple
                      value={props.selectedPayments}
                      onChange={(event) => props.handlePaymentChange1(event.target.value)}
                      renderValue={(selected) => {
                        const validSelected = selected.filter(paymentId => paymentId);
                        return (
                          <div className="vm-edit-payment-chips">
                            {validSelected.map(payment => (
                              <Chip
                                key={payment.id}
                                label={payment.name}
                                onDelete={(event) => props.handleDeletePaymentChip(event, payment)}
                                onMouseDown={(event) => event.stopPropagation()}
                                className="vm-edit-payment-chip"
                              />
                            ))}
                          </div>
                        );
                      }}
                    >
                      {props.paymentList
                        .filter(payment => !props.initialPaymentIds.includes(payment.id))
                        .map(el => (
                          <MenuItem key={el.id} value={el}>{el.name}</MenuItem>
                        ))}
                    </Select>
                  </FormControl>

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="Serial Number"
                    value={props.serialNumber}
                    onChange={(e) => props.handleInputChange("serial_number", e.target.value)}
                  />

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="Slot ID"
                    value={props.formData.slots.map(slot => slot.slot_id).join(", ") || ""}
                    onChange={(e) =>
                      props.handleInputChange("slots", {
                        ...props.formData.slots,
                        slot_id: e.target.value.split(", ").map(Number),
                      })
                    }
                    disabled
                  />

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="MV ID"
                    value={props.formData.slots.map(slot => slot.mv_id).join(", ") || ""}
                    onChange={(e) =>
                      props.handleInputChange("slots", {
                        ...props.formData.slots,
                        mv_id: e.target.value.split(", ").map(Number),
                      })
                    }
                    disabled
                  />

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="Capacity"
                    value={props.formData.slots.map(slot => slot.capacity).join(", ") || ""}
                    onChange={(e) =>
                      props.handleInputChange("slots", {
                        ...props.formData.slots,
                        capacity: e.target.value.split(", ").map(Number),
                      })
                    }
                    disabled
                  />
                  <FormControl className="vm-edit-select" fullWidth>
                    <InputLabel>Franchisee Type</InputLabel>
                    <Select
                      value={props.formData.type || ''}
                      onChange={handleTypeChange}
                      label="Franchise Type"
                    >
                      <MenuItem value="CITY">FOCO (CIty)</MenuItem>
                      <MenuItem value="FRANCHISEE">FOFO (Franchisee)</MenuItem>
                       <MenuItem value="PDF">PDF (Pdf)</MenuItem>
                    </Select>
                  </FormControl>

                  {props.formData.type === "FRANCHISEE" && (
                    <FormControl className="vm-edit-select" fullWidth>
                      <InputLabel>Location Type</InputLabel>
                      <Select
                        value={props.formData.type_detail || ''}
                        onChange={handleDetailChange}
                        label="Location Type"
                      >
                        <MenuItem value="location given by daalchini">Location Given By Daalchini</MenuItem>
                        <MenuItem value="location given by fofo">Location Given By FOFO</MenuItem>
                      </Select>
                    </FormControl>
                  )}



                </div>

                {/* Section 3 */}
                <div className="vm-edit-form-section">
                  <div className="vm-edit-section-number">3</div>

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="BDPOC"
                    value={props.formData.bd_spoc}
                    onChange={(e) => props.handleInputChange("bd_spoc", e.target.value)}
                  />

                  <FormControl className="vm-edit-select">
                    <InputLabel>Location Type</InputLabel>
                    <Select
                      label="Location Type"
                      value={props.formData.address.location_type_id || ""}
                      onChange={(e) => handleLocationTypeChange(e.target.value)}
                    >
                      {props.locationType && props.locationType.map((el, index) => (
                        <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="Location"
                    value={props.formData.address.street}
                    onChange={(e) =>
                      props.handleInputChange("address", {
                        ...(props.formData.address && props.formData.address),
                        street: e.target.value,
                      })
                    }
                  />

                  <FormControl
                    className="vm-edit-select"
                    onFocus={() => setState({ ...state, isStateSelected: true })}
                  >
                    <InputLabel>State</InputLabel>
                    <Select
                      label="State"
                      open={state.showStateList}
                      onClose={() => setState({ ...state, showStateList: false, isStateSelected: false })}
                      onOpen={() => {
                        setState({ ...state, showStateList: true });
                        props.handleGetStateName();
                      }}
                      value={(props && props.formData.address.state) || ""}
                    >
                      {props.stateName.list && props.stateName.list.map((el, index) => (
                        <MenuItem
                          key={index}
                          value={el.name}
                          onClick={() => {
                            props.handleInputChange("state", el.name);
                            setState({ ...state, showStateList: false });
                            props.handleGetCityName(el.id);
                          }}
                        >
                          {el.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl className="vm-edit-select">
                    <InputLabel>
                      {state.isStateSelected ? "City" : "Please select a state*"}
                    </InputLabel>
                    <Select
                      label={state.isStateSelected ? "City" : "Please select a state*"}
                      value={props.formData.address.city || " "}
                      onChange={(event) => props.handleInputChange("city", event.target.value)}
                      disabled={!state.isStateSelected}
                    >
                      {props.cityName && props.cityName.map((el, index) => (
                        <MenuItem key={index} value={el.name}>
                          {el.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="Latitude"
                    value={props.formData.address.latitude || ""}
                    onChange={(e) => props.handleInputChange("latitude", e.target.value)}
                  />

                  <TextField
                    className="vm-edit-input"
                    fullWidth
                    label="Longitude"
                    value={props.formData.address.longitude || ""}
                    onChange={(e) => props.handleInputChange("longitude", e.target.value)}
                  />

                  <div className="vm-edit-image-upload-container">
                    {props.imagePreview ? (
                      <div className="vm-edit-image-preview">
                        <img
                          src={props.imagePreview}
                          alt="Preview"
                          className="vm-edit-preview-image"
                        />
                        <img
                          src={cancel}
                          alt="Cancel"
                          onClick={props.handleCancel}
                          className="vm-edit-cancel-image"
                        />
                      </div>
                    ) : props.fetchedImageUrl ? (
                      <img
                        src={props.fetchedImageUrl}
                        alt="Fetched Image"
                        className="vm-edit-fetched-image"
                      />
                    ) : null}

                    <input
                      accept="image/*"
                      id="uploadImage"
                      type="file"
                      onChange={props.handleFileChange}
                      className="vm-edit-file-input"
                    />

                    <label htmlFor="uploadImage" className="vm-edit-upload-label">
                      <IconButton color="primary" component="span" className="vm-edit-upload-button">
                        <CloudUploadIcon />
                      </IconButton>
                      <span className="vm-edit-upload-text">
                        {props.imagePreview ? "Image Selected" : "Click here to select an image"}
                      </span>
                    </label>

                    <Button
                      variant="outlined"
                      onClick={props.handleImageUpload}
                      className="vm-edit-upload-submit"
                    >
                      Upload
                    </Button>
                  </div>
                </div>
              </div>
            </div>

            <Button
              className="vm-edit-submit-button"
              onClick={props.handleUpdateVMDetails}
            >
              Update Vending Machine
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default VmEditComponent;